<template>
    <icon-base v-bind="$props">
        <path d="M12 3l7 3v6c0 4.5 -3 7.5 -7 9c-4 -1.5 -7 -4.5 -7 -9v-6z" />
        <rect x="10" y="11" width="4" height="3" rx="0.5" />
        <path d="M11 11v-1a1 1 0 0 1 2 0v1" />
    </icon-base>
</template>

<script setup>
import IconBase, { iconProps } from './IconBase.vue'

defineProps(iconProps)
</script>
